import script from "./WaTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./WaTemplates.vue?vue&type=script&setup=true&lang=js"

import "./WaTemplates.vue?vue&type=style&index=0&id=09ec5964&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ec5964"]])

export default __exports__